<template>
  <v-container class="ma-0 pa-0 px-2 pt-8">
    <v-row dense justify="center" align="center">
      <v-col cols="12" class="text-center">
        <v-icon size="82" color="orange">mdi-alert-outline</v-icon>
      </v-col>
      <v-col cols="12" class="text-center">
        Erro ao efetuar o pagamento. Agendamento não criado!!
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
  },
  data: () => ({
  }),
  computed: {
  },
  created() {
  },
  methods: {
  },
  watch: {
  },
  components: {
  },
};
</script>
